import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useAdminAuthCheck = () => {
  const { adminAuth } = useSelector((store) => store.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!adminAuth) {
      navigate("/admin/auth/login");
    }
  }, [adminAuth, navigate]);
};

export default useAdminAuthCheck;
